import React, { useRef } from 'react';
import { motion} from "framer-motion";
import { CgClose } from "react-icons/cg";

function RedirectModal({ setClicked }) {
  const elementsVariant = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        opacity: { duration: 0.5 },
      },
    },
    exit: {
      opacity: 0,

      opacity: { duration: 0.5 },
    },
  };

  const showRef = useRef(false);

  const handleRedirect = () => {
    const currentUrl = window.location.href;
    let dynamicPath = '';

    if (currentUrl.includes('localhost:3002/')) {
      dynamicPath = currentUrl.split('localhost:3002/')[1];
    } else if (currentUrl.includes('ishtari.com.gh/')) {
      dynamicPath = currentUrl.split('ishtari.com.gh/')[1];
    }
  

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const openUrl = `www.ishtari.com.gh://open/${dynamicPath}`;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    showRef.current = true;
    renderButtons();

    if (isAndroid) {
      const intentUrl = `intent://www.ishtari.com.gh/${dynamicPath}#Intent;scheme=https;package=com.smartdevision.app.ishtari;end`;
      window.location = intentUrl;
    } else if (isIOS) {
      window.location = openUrl;
    }
  };

  const openStore = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    showRef.current = false;
    renderButtons();

    if (isAndroid) {
      window.location = "https://play.google.com/store/apps/details?id=com.smartdevision.app.ishtari&pcampaignid=web_share";
    } else if (isIOS) {
      window.open("https://apps.apple.com/app/1248110122");
    }
  };

  const renderButtons = () => {
    const openBtn = document.getElementById("openBtn");
    if (showRef.current) {
      openBtn.onclick = openStore;
    } else {
      openBtn.onclick = handleRedirect;
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center  justify-center bg-dgrey1 bg-opacity-80 shadow-lg" onClick={() => setClicked(true)}>
    <motion.div
      variants={elementsVariant}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="bg-white p-3 rounded-xl shadow-2xl w-full max-w-md mx-4 flex flex-col items-center gap-3 text-center"
    >
  
      <div className="relative w-full py-1  translate-y-[5px]  translate-x-[4px] flex items-center justify-center text-4xl max-md:text-xl font-extrabold text-dblackk">  
        <CgClose className="absolute right-0 cursor-pointer mb-1" />
      </div>
  
      <div className="flex gap-3 w-full px-3">
        <label className="text-[1rem] flex-1 text-start mt-1 relative translate-x-[-3px]">
          For better experience
        </label>
        <button
          id="openBtn"
          onClick={handleRedirect}
          className="font-sans font-semibold text-[15px] relative translate-x-[-8px]  rounded-lg px-3 h-8 bg-dbase text-white border border-dplaceHolder hover:bg-opacity-80"
        >
          Open App
        </button>
      </div>
  
      <div className="flex gap-3 w-full px-3">
        <label className="text-[1rem] flex-1 text-start mt-1 relative translate-x-[-3px]">
          Continue on this website
        </label>
        <button
          id="continueBtn"
          onClick={() => setClicked(true)}
          className="font-sans font-semibold text-[15px] relative translate-x-[-8px]  rounded-lg px-4 h-8 bg-white border border-dplaceHolder hover:bg-opacity-80"
        >
          Continue
        </button>
      </div>
    </motion.div>
  </div>
  );
}

export default RedirectModal;
